<template>
  <div class="flex flex-col items-center justify-center">
    <div class="loading-spinner" />
    <h2 class="mt-2">
      Loading...
    </h2>
  </div>
</template>

<style>
.loading-spinner {
  border: 5px solid var(--md-primary);
  border-top: 10px solid var(--md-tertiary);
  border-radius: 50%;
  width: 100px;
  height: 100px;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
